'use strict';

export default class MxExtensionGalleryService {
	static $inject = ['mx.shell.RoutingService', 'mx.SolutionBuilderAgent.ApiTokenService'];

	constructor(routingService, apiTokenService) {
		this.routingService = routingService;
		this.apiTokenService = apiTokenService;
	}

	async goToExtensionGallery() {
		const accessToken = await this.apiTokenService.generateAccessToken('myGallery', {
			ExtensionGallery: true,
		});
		this.routingService.goToUrl(`https://extensions.matrix42.com#access_token=${accessToken}&target=${encodeURIComponent(window.location.origin)}`, false);
	}
}
